import { serialize } from 'utils/utils';
import { CALL_API, Schemas } from '../middleware/api';

export const TYPES = {
  DELETE_BASESTATE_FIELD_KEY: 'DELETE_BASESTATE_FIELD_KEY',
  CHANGE_BASESTATE_FIELD_KEY: 'CHANGE_BASESTATE_FIELD_KEY',
  BASE_STATE_REQUEST: 'BASE_STATE_REQUEST',
  BASE_STATE_SUCCESS: 'BASE_STATE_SUCCESS',
  BASE_STATE_FAILURE: 'BASE_STATE_FAILURE',
  CHANGE_NUMBER_OF_ADULTS: 'CHANGE_NUMBER_OF_ADULTS',
  CHANGE_NUMBER_OF_CHILDREN: 'CHANGE_NUMBER_OF_CHILDREN',
  CHANGE_CHILD_AGE: 'CHANGE_CHILD_AGE',
  CHANGE_NIGHT_FLEX: 'CHANGE_NIGHT_FLEX',
  SET_ROOMS_VALIDITY: 'SET_ROOMS_VALIDITY',
  UPDATE_PARTY: 'UPDATE_PARTY',
  UPDATE_CAL_DATE: 'UPDATE_CAL_DATE',
};

export const loadBaseState = (params) => {
  const requestObject = Object.assign({
    url: '/holidays/',
  }, params);

  delete requestObject.type;
  delete requestObject.currentStateEncoded;

  if (!requestObject.state) delete requestObject.state;

  return {
    [CALL_API]: {
      types: [
        TYPES.BASE_STATE_REQUEST,
        TYPES.BASE_STATE_SUCCESS,
        TYPES.BASE_STATE_FAILURE,
      ],
      schema: Schemas.BASE_STATE,
      endpoint: `/bridge/baseState?${serialize(requestObject)}`,
    },
  };
};

export const changeNightFlex = value => ({
  type: TYPES.CHANGE_NIGHT_FLEX,
  value,
});

export const deleteFieldKey = (field, id) => ({
  type: TYPES.DELETE_BASESTATE_FIELD_KEY,
  field,
  id,
});

export const changeFieldKey = (field, id, addition) => ({
  type: TYPES.CHANGE_BASESTATE_FIELD_KEY,
  field,
  id,
  addition,
});

export const updateCalDate = calDate => ({
  type: TYPES.UPDATE_CAL_DATE,
  calDate,
});

export const changeNumberOfAdults = (roomNum, numAdults) => ({
  type: TYPES.CHANGE_NUMBER_OF_ADULTS,
  roomNum,
  numAdults,
});

export const changeChildAge = (roomNum, childNumber, age) => (dispatch, getState) => {
  dispatch({
    type: TYPES.CHANGE_CHILD_AGE,
    roomNum,
    childNumber,
    age,
  });
  return Promise.resolve(getState());
};

export const changeNumberOfChildren = (roomNum, numChildren) => ({
  type: TYPES.CHANGE_NUMBER_OF_CHILDREN,
  roomNum,
  numChildren,
});

export const setRoomsValidity = isValid => ({
  type: TYPES.SET_ROOMS_VALIDITY,
  isValid,
});

export const updateParty = rooms => (dispatch) => {
  dispatch({
    type: TYPES.UPDATE_PARTY,
    rooms,
  });
  return Promise.resolve();
};



/** WEBPACK FOOTER **
 ** ./src/redux/actions/baseStateActions.js
 **/